import React, { useCallback, useState, useRef } from 'react'
import { StoryShareModal } from './StorySharedModal'
import { ModalAPI } from './types'

type ModalHandler<Data> = (data: Data) => (api: ModalAPI) => () => void

type UseStoryShareModal<Data> = [React.ReactNode, ModalHandler<Data>]

type ChildrenAdapter<Data> = (data: Data, node: React.ReactNode) => React.ReactNode

export const useStoryShareModal = <T, >(createChildren: ChildrenAdapter<T>): UseStoryShareModal<T> => {

  const [isOpen, setModalStatus] = useState<boolean>(false)

  const modalAPI = useRef<ModalAPI>()

  const dataRef = useRef<T>()

  const handleModal = useCallback<ModalHandler<T>>(
    (data) => (api) => {
      modalAPI.current = api
      dataRef.current = data
      return () => { setModalStatus(true) }
    },
    [],
  )

  return [
    (
      <StoryShareModal
        key="modal-element"
        isOpen={isOpen}
        title={modalAPI.current?.title}
        description={modalAPI.current?.description}
        onShare={modalAPI.current?.onShare}
        handleClose={() => setModalStatus(false)}
      >
        {
          node => (modalAPI.current && dataRef.current) ?
            createChildren(dataRef.current, node) : null
        }
      </StoryShareModal>
    ),
    handleModal,
  ]
}
